module.exports = __webpack_public_path__ + "img/trunk_11x4_z18.dca4843f.svg";